export { default as onSubmitSellerGdm } from './onSubmitSellerGdm';

export type { OnSubmitSellerGdmFunction, OnSubmitSellerGdmPayload } from './onSubmitSellerGdm.type';
